(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("datatables.webcomponent-ld", [], factory);
	else if(typeof exports === 'object')
		exports["datatables.webcomponent-ld"] = factory();
	else
		root["datatables.webcomponent-ld"] = factory();
})(window, function() {
return 